import FilterChiclets from 'components/Catalog/Filters/FilterChiclets/FilterChiclets';
import { withFilterChicletsProps } from 'components/Catalog/Filters/FilterChiclets/withFilterChicletsProps';

export default withFilterChicletsProps(FilterChiclets);
